@if (layoutService.globalSpinnerIsVisible()) {
<div class="spinner-container">
  <mf-spinner size="bigger"></mf-spinner>
</div>
}
